import { OrderRequestActions } from '../actions/index';
import { OrderRequestDetails } from '../order-requet.state';
import { createReducer, on } from '@ngrx/store';
import * as CheckoutActions from '../../../checkout/store/actions/checkout-submit-order.action';

export const initialState: OrderRequestDetails & { rejectedCartGroupIds?: string[] } = {
    loading: null,
    success: null,
    error: null,
    orderRequest: [],
    orderRequestHeader: [],
    totalNumber: null,
    rejectedCartGroupIds: [] 
};

export const orderRequestFetchReducer = createReducer(
    initialState,
    on(OrderRequestActions.fetchOrderRequest, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderRequestActions.fetchOrderRequestSuccess, (state, payload) => {
        // Filter out any cartGroups that have been rejected in this session
        const rejectedIds = state.rejectedCartGroupIds || [];
        const filteredOrderRequest = (payload.orderRequest || []).filter(
            (item) => !rejectedIds.includes(item?.cartGroupId)
        );
        return {
            ...state,
            ...payload,
            orderRequest: filteredOrderRequest,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderRequestActions.fetchOrderRequestFail, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(OrderRequestActions.clearOrderRequest, () => ({
        ...initialState
    })),
    // When an order is rejected in the checkout, immediately remove it from the
    // order-request list in state so the UI updates without waiting for the
    // backend (which has eventual consistency).
    on(CheckoutActions.rejectOrderSuccess, (state, { cartGroupId }) => {
        const rejectedIds = state.rejectedCartGroupIds || [];
        const updatedRejectedIds = rejectedIds.includes(cartGroupId)
            ? rejectedIds
            : [...rejectedIds, cartGroupId];
        const filteredOrderRequest = (state.orderRequest || []).filter(
            (item) => item?.cartGroupId !== cartGroupId
        );
        return {
            ...state,
            orderRequest: filteredOrderRequest,
            totalNumber: filteredOrderRequest.length,
            rejectedCartGroupIds: updatedRejectedIds
        };
    })
);